"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var i18n_1 = __importDefault(require("../../i18n"));
var PhoneEmailVerificationStrings = {
    verifyYourAccount: function () {
        return i18n_1["default"].t('phoneEmailVerificationStrings_verifyYourAccount');
    },
    beforeProceedingVerify: function () {
        return i18n_1["default"].t('phoneEmailVerificationStrings_beforeProceedingVerify');
    },
    tooManyAttemptsExplanation: function () {
        return i18n_1["default"].t('phoneEmailVerificationStrings_tooManyAttemptsExplanation');
    },
    tooManyInvalidAttemptsExplanation: function () {
        return i18n_1["default"].t('phoneEmailVerificationStrings_tooManyInvalidAttemptsExplanation');
    },
    updateNumber: function () { return i18n_1["default"].t('phoneEmailVerificationStrings_updateNumber'); },
    phoneNumberVerification: function () {
        return i18n_1["default"].t('phoneEmailVerificationStrings_phoneNumberVerification');
    }
};
exports["default"] = PhoneEmailVerificationStrings;
